import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AddTagMutationVariables = Types.Exact<{
  input: Types.MutationCreateTagInput;
}>;


export type AddTagMutation = { __typename: 'Mutation', createTag: { __typename: 'Tag', id: string, name: string, color?: string | null, type: Types.TagType, description?: string | null } };

export const AddTagDocument = gql`
    mutation AddTag($input: MutationCreateTagInput!) {
  createTag(input: $input) {
    id
    name
    color
    type
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTagGQL extends Apollo.Mutation<AddTagMutation, AddTagMutationVariables> {
    override document = AddTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }